import Carousel from "../../component/carousel"
import News from "../../component/news"

const Job_Portugal = () => {
  return (
    <>
      {/* HERO / CAROUSEL */}
      <Carousel
        mainText={`We’re Hiring!`}
        smallText={`Events Manager – Portugal`}
        images={["img/slide-01.jpg", "img/slide-01.jpg", "img/slide-01.jpg"]}
      />

      {/* INTRO */}
      <section className="mod-two-cols" data-lazy-load>
        <div className="">
          <div className="grid">
            <div className="grid__item md--two-thirds mod-two-cols--padded">
              <h3 className="heading-1">
                <span>Events Manager – Portugal</span>
              </h3>

              <p
                style={{
                  fontSize: "20px",
                  lineHeight: "120%",
                  marginTop: "15px",
                }}
              >
                At <b>CIMGLOBAL</b>, we don’t just manage conferences—we deliver
                seamless, high-impact experiences that move industries forward.
                As trusted partners to leading international associations and
                scientific societies, we bring strategy, precision, and
                excellence to every event we produce.
              </p>

              <p
                style={{
                  fontSize: "20px",
                  lineHeight: "120%",
                  marginTop: "10px",
                }}
              >
                As we strengthen our presence in <b>Portugal</b>, we are seeking
                a high-performing <b>Events Manager</b> to lead the execution of
                national and international conferences and support ongoing
                association secretariat services—ensuring every project is
                delivered to world-class standards.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* YOUR MISSION */}
      <article
        className="mod-text-media mod-text-media__scheme--Light"
        data-lazy-load
      >
        <div className="mod-text-media__wrapper grid">
          <div className="grid lg--two-thirds md-one-whole mod-two-cols--padded">
            <div className="grid__item">
              <div className="mod-text__content">
                <h3 className="heading-3 mod-text__header mod-text-media__header">
                  Your Mission
                </h3>

                <p
                  style={{
                    fontSize: "20px",
                    lineHeight: "120%",
                    marginTop: "10px",
                  }}
                >
                  <b>Lead teams. Elevate delivery.</b> Bring global-standard
                  operations to life in Portugal.
                </p>

                <p
                  style={{
                    fontSize: "20px",
                    lineHeight: "120%",
                    marginTop: "10px",
                  }}
                >
                  This is a hands-on leadership role responsible for planning,
                  coordinating, and executing conferences and association
                  projects—from concept to completion. You will be the
                  operational backbone of CIMGLOBAL Portugal.
                </p>
              </div>
            </div>
          </div>
        </div>
      </article>

      {/* WHAT YOU WILL DO */}
      <article
        className="mod-text-media mod-text-media__scheme--Light"
        data-lazy-load
      >
        <div className="mod-text-media__wrapper grid">
          <div className="grid lg--two-thirds md-one-whole mod-two-cols--padded">
            <div className="grid__item">
              <div className="mod-text__content">
                <h3 className="heading-3 mod-text__header mod-text-media__header">
                  What You Will Do
                </h3>

                <ul
                  style={{
                    listStyle: "disc",
                    marginLeft: "25px",
                    fontSize: "20px",
                    lineHeight: "120%",
                    marginTop: "5px",
                  }}
                >
                  <li>
                    <b>Lead Event Delivery:</b> Oversee the full operational
                    lifecycle of conferences—from planning and logistics to
                    on-site execution and post-event reporting.
                  </li>
                  <li>
                    <b>Manage Secretariat Services:</b> Support association
                    administration, member communication, meetings, and
                    documentation.
                  </li>
                  <li>
                    <b>Manage Teams & Partners:</b> Coordinate internal teams,
                    suppliers, venues, and service partners.
                  </li>
                  <li>
                    <b>Ensure Excellence:</b> Implement CIMGLOBAL operational
                    standards, timelines, and quality controls.
                  </li>
                  <li>
                    <b>Financial Oversight:</b> Manage budgets, vendor
                    negotiations, and operational profitability.
                  </li>
                  <li>
                    <b>Client Relationship Management:</b> Maintain proactive,
                    solution-focused communication with stakeholders.
                  </li>
                  <li>
                    <b>Risk & Problem Management:</b> Anticipate challenges and
                    resolve issues calmly and decisively.
                  </li>
                  <li>
                    <b>Support Bids & Proposals:</b> Provide operational insights
                    to strengthen winning proposals.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </article>

      {/* WHAT WE’RE LOOKING FOR */}
      <article
        className="mod-text-media mod-text-media__scheme--Light"
        data-lazy-load
      >
        <div className="mod-text-media__wrapper grid">
          <div className="grid lg--two-thirds md-one-whole mod-two-cols--padded">
            <div className="grid__item">
              <div className="mod-text__content">
                <h3 className="heading-3 mod-text__header mod-text-media__header">
                  What We’re Looking For
                </h3>

                <ul
                  style={{
                    listStyle: "disc",
                    marginLeft: "25px",
                    fontSize: "20px",
                    lineHeight: "120%",
                    marginTop: "5px",
                  }}
                >
                  <li>
                    3–5+ years of operational management experience in the MICE,
                    PCO, or association secretariat environment.
                  </li>
                  <li>
                    Proven ability to run complex events and manage multiple
                    projects simultaneously.
                  </li>
                  <li>
                    Experience delivering both event operations and association
                    secretariat services.
                  </li>
                  <li>
                    Strong organisational and leadership skills.
                  </li>
                  <li>
                    Excellent vendor and budget management experience.
                  </li>
                  <li>
                    High client-service orientation and strong stakeholder
                    communication skills.
                  </li>
                  <li>
                    A proactive, solutions-driven mindset with calm
                    decision-making under pressure.
                  </li>
                  <li>
                    <b>Native or fluent Portuguese</b> and <b>fluent English</b>{" "}
                    are essential.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </article>

      {/* WHY CIMGLOBAL */}
      <article
        className="mod-text-media mod-text-media__scheme--Light"
        data-lazy-load
      >
        <div className="mod-text-media__wrapper grid">
          <div className="grid lg--two-thirds md-one-whole mod-two-cols--padded">
            <div className="grid__item">
              <div className="mod-text__content">
                <h3 className="heading-3 mod-text__header mod-text-media__header">
                  Why Build Your Career with CIMGLOBAL?
                </h3>

                <ul
                  style={{
                    listStyle: "disc",
                    marginLeft: "25px",
                    fontSize: "20px",
                    lineHeight: "120%",
                    marginTop: "5px",
                  }}
                >
                  <li>
                    <b>Lead with Autonomy:</b> Take ownership of project delivery
                    in Portugal.
                  </li>
                  <li>
                    <b>Join a Global Leader:</b> Be part of an international PCO
                    known for excellence and innovation.
                  </li>
                  <li>
                    <b>Grow Your Career:</b> Strong progression opportunities as
                    Portugal operations expand.
                  </li>
                  <li>
                    <b>Make a Meaningful Impact:</b> Deliver events and
                    secretariat services that shape industries.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </article>

      {/* HOW TO APPLY */}
      <article
        className="mod-text-media mod-text-media__scheme--Light"
        data-lazy-load
      >
        <div className="mod-text-media__wrapper grid">
          <div className="grid lg--two-thirds md-one-whole mod-two-cols--padded">
            <div className="grid__item">
              <div className="mod-text__content">
                <h3 className="heading-3 mod-text__header mod-text-media__header">
                  How to Apply
                </h3>

                <p
                  style={{
                    fontSize: "20px",
                    lineHeight: "120%",
                    marginTop: "15px",
                  }}
                >
                  If you are an operational leader with a passion for delivering
                  outstanding events and exceptional secretariat services, we
                  would love to meet you.
                </p>

                <p
                  style={{
                    fontSize: "20px",
                    lineHeight: "120%",
                    marginTop: "10px",
                  }}
                >
                  Send your CV and a brief cover letter outlining a recent
                  achievement to:{" "}
                  <a href="mailto:info.portugal@cimglobal.net">
                    <b>
                      <u>info.portugal@cimglobal.net</u>
                    </b>
                  </a>
                </p>
<br></br>
<a class="link link--pointing dot__wrapper mod-related__block link--zoom-image" href="./docs/Events-Manager–Portugal_PT.pdf" target="_blank" title="Read more" rel="noopener" className="link--pointing link--pill ">Read in Portuguese</a>
                

                
              </div>
            </div>
          </div>
        </div>
      </article>

      <News />
    </>
  )
}

export default Job_Portugal
